// extracted by mini-css-extract-plugin
var _1 = "copy_box__b63Al";
export { _1 as "copyBox" }
